
<div class="dynamic-grid tw-relative">
<ng-container table-body *ngIf="data">
    <table class="table table-striped-even table-head-custom table-vertical-center overflow-hidden tw-mb-0">
        <thead>
            <tr>
                <!-- <ng-container *ngFor="let column of columnMap">
                    <th>{{column.enumTitle}}</th>
                </ng-container> -->
                <ng-container *ngFor="let prop of extendingMap">
                    <th>{{ componentVocab+prop.Name | translate}}</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
    <ng-container *ngFor="let item of data;let i=index">
        <tr>
            <ng-container *ngFor="let column of columns">
                <!-- here we render each cell of row-->
                <td>
                    {{td_GetValue(item,column)}}
                </td>
            </ng-container>
            <!-- here we render the editable properties-->
            <ng-container *ngFor="let prop of extendingMap">
                <td>
                    <ng-container *ngIf="prop.Type==ExtendPropertyType.Str">
                        <!-- TODO: Most Render a input type for text data-->
                            <input type="text" [onlyNumbers]="false" matInput  autocomplete="off"
                                class="index-input tw-text-center tw-w-[70px] dir-ltr" [value]="td_GetValue(item,prop.Name)" (change)="setExtendedPropertyValue(prop,item,$event)">
                        <!-- </mat-form-field> -->
                    </ng-container>
                    <ng-container *ngIf="prop.Type==ExtendPropertyType.Num">
                        <!-- TODO: Most Render number input box-->
                            <input type="number" matInput  [onlyNumbers]="true" autocomplete="off" matTooltip="{{componentVocab+prop.Name | translate}}"
                                min="{{getItemPropMinValue(prop,item)}}" max="{{getItemProMaxValue(prop,item)}}"
                                class="index-input tw-text-center tw-w-[70px] dir-ltr" [value]="td_GetValue(item,prop.Name)" (change)="setExtendedPropertyValue(prop,item,$event)">
                        <!-- </mat-form-field> -->
                    </ng-container>
                    <ng-container *ngIf="prop.Type==ExtendPropertyType.Bool">
                        <!-- TODO: Most Render a check box for boolean data type -->
                            <input type="checkbox" [onlyNumbers]="false" matInput matTooltip="{{componentVocab+prop.Name | translate}}"
                                class="index-input tw-text-center tw-w-[70px]" [value]="td_GetValue(item,prop.Name)" (value)="setExtendedPropertyValue(prop,item,$event)">
                        <!-- </mat-form-field> -->
                    </ng-container>
                    <ng-container *ngIf="prop.Type==ExtendPropertyType.Label">
                        <!-- TODO: Most Render a check box for boolean data type -->
                        {{td_GetValue(item,prop.Name)}}
                    </ng-container>
                </td>
            </ng-container>
            <!--end of editable area-->
        </tr>
    </ng-container>
</tbody>
</table>
</ng-container>
</div>
